import { Arg, Metadata } from '../../../utils/spds/metadata';
import { on } from '@ember/modifier';
import FlexRow from '../layout/flex/row.gjs';
import Super from './base.gjs';
import styles from './label.module.scss';

const METADATA = Metadata.define({
  description: 'SPDS-compliant label component',
  meta: {
    for: Arg.string({ description: 'The ID of the form element this label is associated with' }),
    label: Arg.string({ description: 'The label text to display' }).initial('Label'),
    onClick: Arg.action({ description: 'Action to be called when the label is clicked' }),
    required: Arg.boolean({ description: 'Indicates whether the associated field is required' }),
    srOnly: Arg.boolean({
      description: 'Visually hides the label while keeping it accessible to screen readers',
    }),
  },
  name: 'Label',
});

export default class SpdsCoreLabel extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  classesToMapToArgs = ['srOnly', 'required'];
  baseClass = 'spds-label';
  styles = styles;

  handleClick = evt => {
    if (!this.args.onClick) return;

    evt.preventDefault();

    this.args.onClick();
  };

  <template>
    <FlexRow
      @content={{@label}}
      @tag="label"
      class={{this.classes}}
      data-test-spds-label={{this.componentName}}
      id={{this.id}}
      for={{@for}}
      {{this.validateArguments}}
      {{on "click" this.handleClick}}
      ...attributes
    >
      {{yield}}
    </FlexRow>
  </template>
}

export const SPDS_CORE_LABEL_METADATA = SpdsCoreLabel.metadata;
